import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { BookingRulesContainer } from 'src/features/booking-rules/containers/booking-rules';
import { meilisearchSearchSchema } from 'src/hooks/meilisearch/schema/meilisearch-search-schema';

export const Route = createFileRoute('/_layout/tenant/booking-rules/')({
  component: BookingRulesContainer,
  validateSearch: zodValidator(meilisearchSearchSchema),
});
